import React, { Component } from "react";
import { motion } from "framer-motion";
import InfoCard from "../Components/InfoCard";
import ImageGallery from "../Components/ImageGalleryThreeCol";

import shelterManagement from "../Assets/img/design-snippets/sheltermanagement-comp.jpg";
import petJournal from "../Assets/img/design-snippets/petjournal.png";
import leadsRedesign from "../Assets/img/design-snippets/leads-redesign.jpg";

class FunProjects extends Component {
  render() {
    return (
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ y: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.75, ease: "easeOut" }}
      >
        <div className="container">
          <section>
            <h4 className="vertical">Design Snippets</h4>

            <div className="lead green short">
              I like to tinker and experiment. Here’s a collection of some
              design experiments done for fun.
            </div>

            <div className="spacer"></div>

            <div className="row middle-sm">
              <div className="col-md-5">
                <div className="article">
                  <div className="article-number">
                    <h1>01</h1>
                  </div>
                  <h4>Leads Dashboard Redesign</h4>
                  <p>
                    At CINC, the design team was tasked with coming up with
                    ideas of how the leads dashboard, which contains important
                    information about a home buyer, could be redesigned and
                    reimagined. It was also an exercise as a design team to try
                    to figure out what sort of style and patterns we'd want so
                    we could start creating a design system.
                  </p>

                  <p>
                    We envisioned making it visually cleaner and minimal so it
                    would be easier to digest the table of information. Because
                    these were just ideas, they haven't been tested or placed in
                    front of users yet.
                  </p>
                </div>
              </div>
              <div className="col-md-7">
                <img src={leadsRedesign} width="100%" className="img-shadow" />
              </div>
            </div>

            <div className="spacer"></div>

            <div className="row middle-sm">
              <div className="col-md-7">
                <img
                  src={shelterManagement}
                  width="100%"
                  className="img-shadow"
                />
              </div>
              <div className="col-md-5">
                <div className="article">
                  <div className="article-number">
                    <h1>02</h1>
                  </div>
                  <h4>Shelter Management</h4>
                  <p>
                    This was a fun project imagining a more intuitive shelter
                    management software. Volunteering at my local animal
                    shelter, I've seen the software they currently use to keep
                    track of pets at the shelter. It's clunky, hard to use, and
                    nothing but tables from the 90s.
                  </p>

                  <p>
                    Adoption rates are critical for shelters to track their
                    progress. This graph would be front and center. Urgent pets
                    were those that needed to be out of the shelter ASAP. Other
                    supplemental information such as fosters, adoption requests,
                    and so on would surround these data points.
                  </p>
                </div>
              </div>
            </div>

            <div className="spacer"></div>

            <div className="row middle-sm">
              <div className="col-md-7">
                <div className="article">
                  <div className="article-number">
                    <h1>03</h1>
                  </div>
                  <h4>Pet Health Tracker</h4>
                  <p>
                    My dog, Simon, is a senior-aged pup with mobility issues due
                    to degenerative myelopathy. Every week, he goes to physical
                    therapy and it is imperative to track how the treatments are
                    helping him.
                  </p>

                  <p>
                    {" "}
                    One day I felt like it would be great to have an app that
                    tracked a pet's health every day with three easy indicators:
                    happy face, neutral face, and sad face. This could tell you
                    how your pet is doing throughout the week, visually show
                    good and bad days, and also allow for time-stamped
                    observations. A pet parent could easily flip this app open
                    during a vet consultation to explain how their pet is doing.
                  </p>
                </div>
              </div>
              <div className="col-md-5 text-center">
                <img src={petJournal} width="80%" />
              </div>
            </div>
          </section>
          
        </div>
      </motion.div>
    );
  }
}

export default FunProjects;
